var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"caixa-mais-lidos"},[_c('div',{staticClass:"div-img-mais-lidos"},[_c('img',{attrs:{"src":_vm.imagem,"loading":"lazy"}})]),_c('div',{staticClass:"div-conteudo-mais-lidos"},[_c('h4',[_vm._v(_vm._s(_vm.titulo))]),_c('p',[_vm._v(_vm._s(_vm.resumo))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }